import { logToDatadog } from 'services/datadog';
import { newNotification } from '../actions/uiActions';
import { StatusType } from '@datadog/browser-logs';

export const notificationMiddleware = ({ dispatch }) => next => action => {
  if (
    (action?.type?.includes('_FAILURE') || action?.type?.includes('_ERROR')) &&
    action?.meta?.error
  ) {
    try {
      const { error } = action.meta;
      const message = `${action?.type} \n${error?.response?.data?.errorCode ?? ''} \n${error?.response?.data?.errorDetail ?? error?.response?.data?.errorMessage ?? error?.response?.data ?? 'no error message'} `

      dispatch(
        newNotification({
          variant: 'error',
          message: message
        })
      );
      logToDatadog("error_notif_showing", {
        action: JSON.stringify(action),
        error: JSON.stringify(error),
        response: JSON.stringify(error?.response),
        message
      }, StatusType.error);

    } catch (err) {
      console.log(err);
    }
  } else if (
    (action?.type?.includes('_FULFILLED') ||
      action?.type?.includes('_SUCCESS')) &&
    action?.meta?.success
  ) {
    try {
      const { success } = action?.meta;
      dispatch(
        newNotification({
          variant: 'success',
          message: `${action?.type} \n${success?.message || ''} `
        })
      );
    } catch (err) {
      console.log(err);
    }
  }
  next(action);
};
